<!-- <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [disableDefaultUI]="true" [zoomControl]="true">

  <agm-marker-cluster [calculator]="calculateFunction" [minimumClusterSize]="clusterOptions.minimumClusterSize"
    [styles]="clusterStyles"  (mouseOver)="onMouseOver(marker, $event)" (mouseOut)="onMouseOut(marker, $event)">
    <div *ngFor="let m of markers | slice:1:markers.length-1 ; let i = index">
      <agm-marker [latitude]="m.lat" [longitude]="m.lng" [label]="m.label" [markerDraggable]="m.draggable"
        [markerClickable]="true" (markerClick)="zoomPosition(m.lat,m.lng,30) " >



      </agm-marker>

      <agm-info-window [disableAutoPan]="true">
hiiiii
      </agm-info-window> 


    </div>
  </agm-marker-cluster>
  <div *ngFor="let m of markers ; let i = index">
    <agm-marker [iconUrl]="iconStart" *ngIf="i === 0" [latitude]="m.lat" [longitude]="m.lng"
      [markerDraggable]="m.draggable" [markerClickable]="true" (markerClick)="zoomPosition(m.lat,m.lng,30) ">



    </agm-marker>

    <agm-marker [iconUrl]="iconEnd" *ngIf="i == markers.length-1" [latitude]="m.lat" [longitude]="m.lng"
      [markerDraggable]="m.draggable" [markerClickable]="true" (markerClick)="zoomPosition(m.lat,m.lng,30) ">



    </agm-marker>
  </div>
  <agm-polyline [strokeColor]="'#4285f4'" [strokeOpacity]="0.9">
    <agm-icon-sequence [fixedRotation]="false" [repeat]="'60px'" [offset]="100" [path]="'FORWARD_CLOSED_ARROW'">
    </agm-icon-sequence>
    <agm-polyline-point *ngFor="let m of markers; let i = index" [latitude]="m.lat" [longitude]="m.lng">
    </agm-polyline-point>
  </agm-polyline>
</agm-map>

<h1>Angular Google Maps (AGM) Demo</h1>
<p><a href="https://angular-maps.com/" target="_blank">Official Website</a></p>
<button (click)="drawPath()">dfgdfg</button>

<h1>Travel Marker Angular Google Maps (AGM) Demo</h1>
<p><a href="https://github.com/ManpreetSingh80/travel-marker" target="_blank">Github</a></p>
<div *ngFor="let m of routeJSON   ; let i = index">
  {{m}}
</div>
<agm-map [latitude]="lat1" [longitude]="lng1" [zoom]="zoom1" (mapReady)="onMapReady($event)">

</agm-map>

<div class="controls">
  <button (click)="play()">Play</button>
  <button (click)="pause()">Pause</button>
  <button (click)="reset()">Reset</button>
  <button (click)="next()">Next</button>
  <button (click)="prev()">Previous</button>
  <button (click)="fast()">Fast</button>
  <span id="speed">Speed: {{ speedMultiplier }}x</span>
  <button (click)="slow()">Slow</button>
</div> -->

<agm-map [latitude]="6.9271" [longitude]="79.8612">
  <agm-marker     [latitude]="6.8403134" [longitude]="80.0021128"
       [markerClickable]="true"  >



    </agm-marker>

    <agm-marker     [latitude]="6.4319639" [longitude]="79.9983415 "
    [markerClickable]="true"  >



 </agm-marker>
  <agm-direction [origin]="{ lat: 6.8403134, lng: 80.0021128 }" [destination]="{ lat: 6.71532762, lng: 80.06215197 }">
  </agm-direction>
 
   <agm-direction [origin]="{ lat: 6.4319639, lng: 79.9983415 }" [destination]="{ lat: 6.73906232, lng: 80.15640132 }">
   </agm-direction>
 
   <agm-direction [origin]="{ lat: 6.71532762, lng: 80.06215197 }" [destination]="{ lat: 6.4319639, lng: 79.9983415 }">
   </agm-direction>
 
 </agm-map>